<div [class]="customClass">
  <small>
    <a (click)="openVersion()"> versão 1.4.3 ({{amb}}) </a>
  </small>
</div>